import AddressLines from './components/form-address-lines';
import Checkbox from './components/form-checkbox';
import CheckboxGroup from './components/form-checkbox-group';
import Country from './components/form-country';
import FormDate from './components/form-date';
import Dob from './components/form-dob';
import Ein from './components/form-ein';
import Email from './components/form-email';
import Group from './components/form-group';
import Input from './components/form-input';
import JsonEditor from './components/form-json-editor';
import MarkdownEditor from './components/form-markdown-editor';
import MultiSelect from './components/form-multi-select';
import FormNumber from './components/form-number';
import Otp from './components/form-otp';
import Radio from './components/form-radio';
import RadioGroup from './components/form-radio-group';
import SchemaEditor from './components/form-schema-editor';
import Select from './components/form-select';
import Ssn4 from './components/form-ssn4';
import Ssn9 from './components/form-ssn9';
import Tel from './components/form-tel';
import TemplateInput from './components/form-template-input';
import TemplateTextarea from './components/form-template-textarea';
import Textarea from './components/form-textarea';
import Toggle from './components/form-toggle';
import UsState from './components/form-us-state';
import UsTaxId from './components/form-us-tax-id';
import Vin from './components/form-vin';
import Zip from './components/form-zip';

const Form = {
  AddressLines,
  Checkbox,
  CheckboxGroup,
  Country,
  Date: FormDate,
  Dob,
  Ein,
  Email,
  Group,
  Input,
  JsonEditor,
  MarkdownEditor,
  MultiSelect,
  Number: FormNumber,
  Otp,
  Radio,
  RadioGroup,
  SchemaEditor,
  Select,
  Ssn4,
  Ssn9,
  Tel,
  TemplateInput,
  TemplateTextarea,
  Textarea,
  Toggle,
  UsState,
  UsTaxId,
  Vin,
  Zip,
};

export default Form;
